import React, { useState, useEffect } from "react";
import ProdcutService from "api/precision/ProdcutService";
import XmpieService from "api/precision/XmpieService";
import BoxSleeve from "./see/BoxSleeve";
import { useAdors } from "context/AdorsContext";
import moment from 'moment';


// To list products: remove pid, keep pcid
// Current See
// sid = sessionId constant, cid = customer Id, pcid = product category Id, fid = form ID
// http://localhost:3000/sees?token=cecbc0d6c7abb0dcb6f609d8ad6c0b09af1dc87da5ff042b373620ca97fdc4ec&cid=2177&sid=12345&pcid=2218&fid=1

// Google site key: 6LeSkYcoAAAAACdgG4OKdVWi6X2u-uARngXzGvUn
// Google Secret: 6LeSkYcoAAAAAJrE7JZ01ZvVN6RF6rzQ_kZQlahf

export default function Customize({ useSession, useShoppingCart }) {
  // Reuse shopping cart
  const { addToCart, removeFromCart, updateCartItem, cartItems, emptyCart } = useShoppingCart();
  const { adors, getAdor, getAdorValue, saveAdors, updateAdorValue } = useAdors();

  const { getProfile, saveProfile, logout } = useSession();
  // Customize session
  const [session, setSession] = useState(getProfile());
  // All templates and products
  const [templates, setTemplates] = useState(null);

  // Current template
  const [curTemplateName, setCurTemplateName] = useState(null);

  // Validation list
  const [validations, setValidations] = useState(null);

  useEffect(() => {
    const templates = {
      custom: {
        layout: {
          backdrop: {
            backdropImage: "custom.jpg",
            boxLeft: "0px",
            boxTop: "0px",
            boxWidth: "100%",
            boxHeight: "100%"
          },
          // message: {
          //   text: "",
          //   boxLeft: "8%",
          //   boxTop: "52%",
          //   boxWidth: "32%",
          //   boxHeight: "1.2em",
          //   maxLength: 50
          // }
        },
        products: [
          {
            "id": 157528,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - 4 oz. Box",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 157917,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - 4 oz. Box - Coated Cover with Raised Foil - POD ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 144661,
            "customer_id": 2177,
            "name": "8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 157919,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - 8 oz. Box - Coated Cover with Raised Foil - POD ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 144571,
            "customer_id": 2177,
            "name": "Nuts & Chews 1 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 157926,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - Nuts & Chews 1 lb. Box - Coated Cover with Foil - POD ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 144577,
            "customer_id": 2177,
            "name": "Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 157930,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - Nuts & Chews 2 lb. Box - Coated Cover with Foil - POD ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 144553,
            "customer_id": 2177,
            "name": "Regular 1 lb. Box",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 157923,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - Regular 1 lb. Box - Coated Cover with Foil - POD",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 144561,
            "customer_id": 2177,
            "name": "Regular 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 157929,
            "customer_id": 2177,
            "name": "Candy Box Sleeve - Regular 2 lb. Box - Coated with Raised Foil - POD ",
            "min_quantity": 50,
            "max_quantity": 9999999
          }
        ]
      },
      whiteSnowflakes: {
        layout: {
          backdrop: {
            backdropImage: "white-gold-snowflakes.jpg",
            boxLeft: "8%",
            boxTop: "5%",
            boxWidth: "300px",
            boxHeight: "150px",
            backgroundColor: "#fff",
            fontSize: "16px"
          },
          message: {
            text: "",
            boxLeft: "13%",
            boxTop: "7%",
            boxWidth: "220px",
            boxHeight: "80px",
            fontColor: "#000",
            fontSize: "16px",
            backgroundColor: "transparent"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      whiteSnowflakes5535: {
        layout: {
          backdrop: {
            backdropImage: "white-gold-snowflakes.jpg",
            boxLeft: "4%",
            boxTop: "5%",
            boxWidth: "200px",
            boxHeight: "100px",
            backgroundColor: "#fff",
            fontSize: "14px"
          },
          message: {
            text: "",
            boxLeft: "8.5%",
            boxTop: "7%",
            boxWidth: "160px",
            boxHeight: "60px",
            fontColor: "#000",
            fontSize: "12.5px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      redSnowflakes: {
        layout: {
          backdrop: {
            backdropImage: "red-white-snowflakes.jpg",
            boxLeft: "8%",
            boxTop: "5%",
            boxWidth: "300px",
            boxHeight: "150px",
            backgroundColor: "transparent",
            fontSize: "16px"
          },
          message: {
            text: "",
            boxLeft: "13%",
            boxTop: "7%",
            boxWidth: "220px",
            boxHeight: "80px",
            fontColor: "#fff",
            fontSize: "16px",
            backgroundColor: "transparent"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      redSnowflakes5535: {
        layout: {
          backdrop: {
            backdropImage: "red-white-snowflakes.jpg",
            boxLeft: "4%",
            boxTop: "5%",
            boxWidth: "200px",
            boxHeight: "100px",
            backgroundColor: "transparent",
            fontSize: "14px"
          },
          message: {
            text: "",
            boxLeft: "8.5%",
            boxTop: "7%",
            boxWidth: "160px",
            boxHeight: "60px",
            fontColor: "#fff",
            fontSize: "12.5px",
            backgroundColor: "transparent"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      house9944: {
        layout: {
          backdrop: {
            backdropImage: "house_99_44.jpg",
            boxLeft: "8%",
            boxTop: "5%",
            boxWidth: "300px",
            boxHeight: "150px",
            backgroundColor: "#fff",
            fontSize: "16px"
          },
          message: {
            text: "",
            boxLeft: "13%",
            boxTop: "7%",
            boxWidth: "220px",
            boxHeight: "80px",
            fontColor: "#028050",
            fontSize: "16px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      house9757: {
        layout: {
          backdrop: {
            backdropImage: "house_97_57.jpg",
            boxLeft: "8%",
            boxTop: "5%",
            boxWidth: "300px",
            boxHeight: "150px",
            backgroundColor: "#fff",
            fontSize: "16px"
          },
          message: {
            text: "",
            boxLeft: "13%",
            boxTop: "7%",
            boxWidth: "220px",
            boxHeight: "80px",
            fontColor: "#028050",
            fontSize: "16px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      house5535: {
        layout: {
          backdrop: {
            backdropImage: "house_55_35.jpg",
            boxLeft: "4%",
            boxTop: "5%",
            boxWidth: "200px",
            boxHeight: "100px",
            backgroundColor: "#fff",
            fontSize: "14px"
          },
          message: {
            text: "",
            boxLeft: "8.5%",
            boxTop: "7%",
            boxWidth: "160px",
            boxHeight: "60px",
            fontColor: "#028050",
            fontSize: "12.5px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159371,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - 8 oz. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159373,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 1 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159375,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159378,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 1 lb. Box ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159380,
            "customer_id": 2177,
            "name": "White Star Template Candy Box Sleeve - Regular 2 lb. Box ",
            "min_quantity": 10,
            "max_quantity": 9999999
          }
        ]
      },
      confetti: {
        layout: {
          backdrop: {
            backdropImage: "confetti.jpg",
            boxLeft: "calc(50% - 150px)",
            boxTop: "5%",
            boxWidth: "300px",
            boxHeight: "150px",
            backgroundColor: "#fff",
            fontSize: "16px"
          },
          message: {
            text: "",
            boxLeft: "calc(50% - 110px)",
            boxTop: "7%",
            boxWidth: "220px",
            boxHeight: "80px",
            fontColor: "#000",
            fontSize: "16px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159368,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - 4 oz. Box ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 159370,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - 8 oz. Box  ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159372,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Nuts & Chews 1 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159374,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159376,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Regular 1 lb. Box  ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159379,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Regular 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          }],
      },
      confetti5535: {
        layout: {
          backdrop: {
            backdropImage: "confetti.jpg",
            boxLeft: "calc(50% - 100px)",
            boxTop: "5%",
            boxWidth: "200px",
            boxHeight: "100px",
            backgroundColor: "#fff",
            fontSize: "14px"
          },
          message: {
            text: "",
            boxLeft: "calc(50% - 80px)",
            boxTop: "7%",
            boxWidth: "160px",
            boxHeight: "60px",
            fontColor: "#000",
            fontSize: "12.5px",
            backgroundColor: "#fff"
          }
        },
        products: [
          {
            "id": 159368,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - 4 oz. Box ",
            "min_quantity": 50,
            "max_quantity": 9999999
          },
          {
            "id": 159370,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - 8 oz. Box  ",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159372,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Nuts & Chews 1 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159374,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Nuts & Chews 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          },
          {
            "id": 159376,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Regular 1 lb. Box  ",
            "min_quantity": 5,
            "max_quantity": 9999999
          },
          {
            "id": 159379,
            "customer_id": 2177,
            "name": "Confetti Template Candy Box Sleeve - Regular 2 lb. Box",
            "min_quantity": 10,
            "max_quantity": 9999999
          }],
      },
    };
    setTemplates(templates);
    setCurTemplateName("custom");
  }, []);

  return templates && (
    <section className="psg">
      <BoxSleeve templates={templates} curTemplateName={curTemplateName} />
    </section>
  );
}
